import { useEffect } from 'react'
import './index.scss'

export default function Home() {
    useEffect(() => {
        window.location.replace('https://www.vibra.one/')
    }, [])
    return <div className="title">Redirecting...</div>
}